import http from '../../../../api/httpClient';

export const getUsers = async () => {
  try {
    const response = await http.get('/api/v1/cto/users');
    return response;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const deleteUser = async (ecode: string) => {
  try {
    const response = await http.delete(`/api/v1/cto/users/${ecode}`);
    return response;
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
};

export const updateUser = async (ecode: string, userData: any) => {
  try {
    const response = await http.put(`/api/v1/cto/users/${ecode}`, userData);
    return response;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

export const createUser = async (userData: any) => {
  try {
    const response = await http.post('/api/v1/cto/users/create', userData);
    return response;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};
